import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalDate } from '../../../core/pojo/date-variable';

@Injectable({
  providedIn: 'root',
})
export class MarketAnalysisInternalService {
  private _maReportedPeriod = new BehaviorSubject<LocalDate[]>(undefined);
  private _selectedPeriodForMarketAnalysis = new BehaviorSubject<LocalDate>(undefined);
  private _vintagePeriods = new BehaviorSubject<LocalDate[]>(undefined);
  private _selectedVintageFrom = new BehaviorSubject<LocalDate>(undefined);
  private _selectedVintageTill = new BehaviorSubject<LocalDate>(undefined);

  reportedPeriodsState = this._maReportedPeriod.asObservable();
  selectedPeriodForMarketAnalysisState = this._selectedPeriodForMarketAnalysis.asObservable();
  vintagePeriodsState = this._vintagePeriods.asObservable();
  selectedVintageFromState = this._selectedVintageFrom.asObservable();
  selectedVintageTillState = this._selectedVintageTill.asObservable();

  // Public methods to send data
  sendReportedPeriods(data: LocalDate[]): void {
    this._maReportedPeriod.next(data);
  }

  sendSelectedReportedPeriod(selectedPeriod: LocalDate): void {
    this._selectedPeriodForMarketAnalysis.next(selectedPeriod);
  }

  sendVintagePeriods(selectedPeriods: LocalDate[]): void {
    this._vintagePeriods.next(selectedPeriods);
  }

  sendSelectedVintageFrom(selectedPeriod: LocalDate): void {
    this._selectedVintageFrom.next(selectedPeriod);
  }

  sendSelectedVintageTill(selectedPeriod: LocalDate): void {
    this._selectedVintageTill.next(selectedPeriod);
  }
}
